import { OpenInNewIcon } from './OpenInNewIcon';

/**
 * author: Google
 * id 12B95238-1D74-4C6C-9BBD-C055B4DD0E4D
 * name open-in-new
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/open-in-new.svg
 * tags
 */
export const ExternalLinkIcon = OpenInNewIcon;
export default ExternalLinkIcon